import AreaFilterDefinition from '../AreaFilterDefinition';
import ContinentFilterDefinition from '../ContinentFilterDefinition';
import { CountryFilterDefinition } from '../CountryFilterDefinition';
import DisciplineFilterDefinition from '../DisciplineFilterDefinition';
import DistanceLearningAttendanceFilterDefinition from './DistanceLearningAttendanceFilterDefinition';
import DistanceLearningDurationFilterDefinition from './DistanceLearningDurationFilterDefinition';
import DistanceLearningFormatFilterDefinition from './DistanceLearningFormatFilterDefinition';
import DistanceLearningSpecialProgrammesFilterDefinition from './DistanceLearningSpecialProgrammesFilterDefinition';
import DistanceLearningTuitionFeeFilterDefinition from './DistanceLearningTuitionFeeFilterDefinition';
import EducationLevelFilterDefinition from '../EducationLevelFilterDefinition';
import { EducationLevelFilterOptionValue } from '@studyportals/search-filters/server-side';
import { PortalDefinition } from '../PortalDefinition';
import OrganisationFilterDefinition from '../OrganisationFilterDefinition';
import CampaignTypeFilterDefinition from '../CampaignTypeFilterDefinition';

class DistanceLearningPortalDefinition extends PortalDefinition {
	public constructor() {
		super(
			[
				OrganisationFilterDefinition,
				DistanceLearningAttendanceFilterDefinition,
				DisciplineFilterDefinition,
				DistanceLearningDurationFilterDefinition,
				DistanceLearningFormatFilterDefinition,
				DistanceLearningSpecialProgrammesFilterDefinition,
				DistanceLearningTuitionFeeFilterDefinition,
				EducationLevelFilterDefinition,
				AreaFilterDefinition,
				ContinentFilterDefinition,
				CampaignTypeFilterDefinition,
				new CountryFilterDefinition(),
			],
			['82', '30', '202', '56', '11'],
			'Online programmes',
			'distance-learning',
			EducationLevelFilterOptionValue.DISTANCE_LEARNING,
			'Online programmes',
		);
	}
}

export default new DistanceLearningPortalDefinition();
